import * as actionTypes from '../constants/categoryConstants';

// export const ccategoryReducer = ( state = { categoryList: [] },action) => {

//     switch (action.type){
//         case actionTypes.ALL_CATEGORY_REQUEST:
//             return {
//                 loading: true,
//                 categoryList: []
//             };
//             case actionTypes.ALL_CATEGORY_REQ_SUCCESS:
//                 return {
//                     loading: false,
//                     categoryList: action.payload.categoryList,
//                 };
//             case actionTypes.ALL_CATEGORY_REQ_FAIL:
//                  return {
//                     loading: false,
//                      error: action.payload
//                 };
//                  default:
//                  return state;
//     }
// };

export const categoryReducer = ( state = { categoryList: [] },action) => {

    switch (action.type){
        case actionTypes.ALL_CATEGORY_REQUEST:
            return {
                loading: true,
                categoryList: []
            };
            case actionTypes.ALL_CATEGORY_REQ_SUCCESS:
                return {
                    loading: false,
                    categoryList: action.payload.categoryList,
                };
            case actionTypes.ALL_CATEGORY_REQ_FAIL:
                 return {
                    loading: false,
                     error: action.payload
                };
                 default:
                 return state;
    }
};




// export const categoryReducer = (state = {categories: []}, action) => {
//     switch(action.type){
//         case actionTypes.ALL_CATEGORY_REQ_SUCCESS:
//             state = {
//                 ...state,
//                 categories: action.payload.categories
//             }

     
//     }

//     return state;
// }